import H4 from 'components/H4';
import H5 from 'components/H5';
import React from 'react';
import styled from 'styled-components';

const Img = styled.img`
    margin-top: 5px;
    width: 52px;
    height: 52px;
`
const TextWrapper = (props) => {
    const { title, img, description, maxWidth } = props;
    return (
        <div className={`d-flex flex-column ${maxWidth ? "col-12" : "col-6"}`}>
            <H5 color="#838990">{title}</H5>
            {img && <Img src={img} />}
            {description && <H4 className="number-of-lines-1 w-100">{description}</H4>}
        </div>
    )
}

export default TextWrapper;